/**
 * Fetch every page from a cursor-based list API.
 * @param {(lastEvaluatedKey: object|null) => Promise<{ success: boolean, data?: { items?: object[], lastEvaluatedKey?: object|null }, error?: unknown }>} fetchPage
 */
export async function fetchAllEvaluatedKeyPages(fetchPage) {
  const items = [];
  let lastEvaluatedKey = null;

  for (;;) {
    const result = await fetchPage(lastEvaluatedKey);
    if (!result?.success) {
      return result;
    }

    const pageItems = result.data?.items ?? [];
    items.push(...pageItems);

    lastEvaluatedKey = result.data?.lastEvaluatedKey ?? null;
    if (!lastEvaluatedKey) {
      return {
        success: true,
        data: { items, count: items.length, lastEvaluatedKey: null },
      };
    }
  }
}

/**
 * @param {(nextToken: string|null) => Promise<{ items: object[], nextToken: string|null }>} fetchPage
 */
export async function fetchAllNextTokenPages(fetchPage) {
  const items = [];
  let nextToken = null;

  for (;;) {
    const page = await fetchPage(nextToken);
    const pageItems = page?.items ?? [];
    items.push(...pageItems);
    nextToken = page?.nextToken ?? null;
    if (!nextToken) {
      return { items, nextToken: null };
    }
  }
}
